const DIETITIAN_PREMIUM = 'dietitian_premium';
const DIETITIAN_STANDARD = 'dietitian_standard';
const DIETITIAN_STUDENT = 'dietitian_student';
const DIETITIAN_TEST = 'dietitian_test';
const DIETITIAN_INACTIVE = 'dietitian_inactive';
const DIETITIAN_EDUCATION = 'dietitian_education';
const DIETITIAN_FREE = 'dietitian_free';
const PATIENT = 'patient';
const EMPLOYEE = 'employee';
const ADMINISTRATOR = 'administrator';

export {
    DIETITIAN_PREMIUM,
    DIETITIAN_STANDARD,
    DIETITIAN_STUDENT,
    DIETITIAN_TEST,
    DIETITIAN_INACTIVE,
    DIETITIAN_EDUCATION,
    DIETITIAN_FREE,
    PATIENT,
    EMPLOYEE,
    ADMINISTRATOR,
};